/**
 * Environment indicator badge for non-production environments
 */
export function EnvironmentBadge() {
  const apiUrl = import.meta.env.VITE_API_URL || '';
  const isLocal = apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1');
  const isStaging = apiUrl.includes('staging');

  if (!isLocal && !isStaging) return null;

  const label = isLocal ? 'LOCAL' : 'STAGING';
  const bgColor = isLocal ? 'bg-blue-500' : 'bg-amber-500';

  return (
    <div className="fixed top-0 left-1/2 -translate-x-1/2 z-[9999] pointer-events-none">
      <div className={`${bgColor} text-white text-xs font-bold px-3 py-1 rounded-b-md shadow-lg`}>
        {label}
      </div>
    </div>
  );
}
